import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import GlobalContainer from '../../../../components/common/Containers/GlobalContainer';
import Header from '../../../../components/common/Header/Header';
import { PDDForm } from './PDDForm';
export const PDDFormSummary = () => {
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsxs("title", { children: ["SIGNO | ", t('summaryForm.titlePage')] }) }), _jsxs(GlobalContainer, { children: [_jsx(Header, { titlePage: t('summaryForm.titlePage') }), _jsx(PDDForm, { isReadMode: true })] })] }));
};
